import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';
export const GET_UNUSED_FILTERS = registerQuery({
  fieldName: 'unusedFilters',
  fetcher: () => ecosystemClient.getUnusedFilters()
});